export function isValidTab<TabsKeys extends string>(
  value: string,
  tabsKeysArray: readonly TabsKeys[],
): value is TabsKeys {
  return tabsKeysArray.includes(value as TabsKeys)
}
